import React from 'react'
import styled from 'styled-components'

const TextArea = styled.textarea`
  width: 100%;
  max-width: 720px;
  min-height: 108px;
  padding: 12px 16px;
  resize: vertical;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 16px;
  line-height: 1.4;
`
const Counter = styled.span`
  display: block;
  align-self: flex-start;   /* ⬅ força alinhar à esquerda */
  margin-top: -15px;          /* (opcional) afastamento do textarea */
  font: 12px/1 'Inter', sans-serif;
  color: #6b7280;
  text-align: left;
`

export default function ShortTextInput({ value, max, onChange }) {
    const current = value.length || 0

  return (
    <>
      <TextArea
        placeholder="Digite o feedback"
        value={value}
        maxLength={max}
        onChange={e => onChange(e.target.value)}
      />
      {max && <Counter>{current}/{max}</Counter>}

    </>

    
  )
}
